import * as XLSX from "xlsx"
import moment from "moment"

// Shared Excel export for Bank Statement / Credit Card reconcile. `rows` come
// from the backend's /export/entries endpoint, which already resolves each
// match into linked_record / linked_party / linked_date / linked_amount.

const fmtDate = d => (d && moment(d).isValid() ? moment(d).format("DD-MM-YYYY") : "")
const num = v => (v == null || v === "" ? "" : Number(v))

const matchModeLabel = row => {
    if (row.status !== "matched") return ""
    if (String(row.matched_type || "").startsWith("shareholder")) return "Acknowledgement"
    if (row.matched_type === "bill_payment") return "Acknowledgement"
    return row.link_mode === "map" ? "Linked to existing" : "New entry created"
}

export const exportStatementExcel = ({ rows, typeLabels, sourceHeader, sourceKey, fileName }) => {
    const sheetRows = rows.map(r => ({
        [sourceHeader]: r[sourceKey] || "",
        "Date": fmtDate(r.statement_date),
        "Reference No": r.reference_no || "",
        "Description": r.description || "",
        "Debit": Number(r.debit) || "",
        "Credit": Number(r.credit) || "",
        "Status": r.status === "matched" ? "Matched" : "Unmatched",
        "Mapped To": r.status === "matched" ? typeLabels[r.matched_type] || r.matched_type || "" : "",
        "Match Mode": matchModeLabel(r),
        "Linked Record": r.linked_record || "",
        "Client / Category / Account": r.linked_party || "",
        "Linked Record Date": fmtDate(r.linked_date),
        "Linked Record Amount": num(r.linked_amount),
        "System Amount": num(r.system_amount),
        "Difference": num(r.difference),
        "Notes": r.notes || "",
        "Matched On": r.matched_at ? moment(r.matched_at).format("DD-MM-YYYY HH:mm") : "",
    }))

    const ws = XLSX.utils.json_to_sheet(sheetRows)
    ws["!cols"] = [18, 12, 18, 45, 12, 12, 11, 24, 18, 32, 28, 16, 18, 14, 12, 30, 17].map(wch => ({ wch }))
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Entries")
    XLSX.writeFile(wb, fileName)
}
